import React, { useState } from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { cookies_string } from '../../../config.js';
import { Login } from '../../../actions/actions.js';
import { useNavigate, useLocation } from 'react-router-dom';
import HomeSvg from '../../../svg/menu/Home.js';
import MissionsSvg from '../../../svg/menu/Missions.js';
import ResultsSvg from '../../../svg/menu/Results.js';
import UsersSvg from '../../../svg/menu/Users.js';
import FaqSvg from '../../../svg/menu/Faq.js';
import PersonalInfoSvg from '../../../svg/menu/PersonalInfo.js';
import LogoutSvg from '../../../svg/menu/Logout.js';
import { useSetting } from '../../../util/useSetting.js';
function Component(props) {
    const { fontSize } = useSetting();
    const navigate = useNavigate();
    const location = useLocation();
    const [__, _, removeCookie] = useCookies([`${cookies_string}_cred`, `${cookies_string}_token`]);
    const [isShowMenu, setisShowMenu] = useState(false)
    const handleLogout = () => {
        props.dispatch(Login(false))
        removeCookie(`${cookies_string}_token`, '/')
        removeCookie(`${cookies_string}_cred`, '/')
        navigate('/platform2/login-new');
    }
    const toggleMenu = () => { setisShowMenu(!isShowMenu) }
    const handleRoute = (route) => () => {
        navigate(`/platform2/${route}`);
    }
    if (location.pathname.split('/')[2] === 'missions' && location.pathname.split('/')[3])
        return null;
    if (location.pathname.split('/')[2] === 'research-practices' && location.pathname.split('/')[3] && location.pathname.split('/')[3] !== 'preview')
        return null;
    return (
        <div className='flex flex-col justify-between items-center p-[16px] bg-[#FAFEFF] h-full' style={{ borderRight: '1px solid #D7D7D7', overflowY: 'auto', backgroundImage: 'url(/secondary/menu/bg.png)', backgroundRepeat: 'no-repeat', backgroundSize: 'cover', fontSize: fontSize + 4 }}>
            <div className='flex flex-col items-stretch gap-[16px] flex-1' style={{ overflowY: "auto" }}>
                <div className='text-center text-[#34778C] py-[16px] font-[900]' style={{ fontSize: fontSize + 8 }}>網讀無界</div>
                <div onClick={handleRoute('')} className='cursor-pointer flex flex-row items-center rounded-[16px] p-[16px] gap-[8px] pr-[24px]'
                    style={['', '/', '/home'].includes(location.pathname.split('/')[2]) ? { opacity: 1, background: 'linear-gradient(to right, #10AEC450, #FFFFFF)', borderLeft: '8px solid #10AEC4' } : { opacity: .5, borderLeft: '8px solid transparent' }}
                >
                    <img src='/secondary/menu/home.png' alt='首頁' style={{ height: '36px', objectFit: 'contain' }} />
                    <div className='font-[700] flex-1 text-center' style={{ color: ['', 'home'].includes(location.pathname.split('/')[2]) ? "#43528A" : '#34778C' }}>首頁</div>
                </div>
                <div onClick={handleRoute('missions')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[16px] p-[16px] gap-[8px] pr-[24px]'
                    style={['missions'].includes(location.pathname.split('/')[2]) ? { opacity: 1, background: 'linear-gradient(to right, #10AEC450, #FFFFFF)', borderLeft: '8px solid #10AEC4' } : { opacity: .5, borderLeft: '8px solid transparent' }}
                >
                    <img src='/secondary/menu/read.png' alt='' style={{ height: '36px', objectFit: 'contain' }} />
                    <div className='font-[700] flex-1 text-center' style={{ color: ['missions'].includes(location.pathname.split('/')[2]) ? "#43528A" : '#34778C' }}>單元總覽</div>
                </div>
                <div onClick={handleRoute('results')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[16px] p-[16px] gap-[8px] pr-[24px]'
                    style={['results'].includes(location.pathname.split('/')[2]) ? { opacity: 1, background: 'linear-gradient(to right, #10AEC450, #FFFFFF)', borderLeft: '8px solid #10AEC4' } : { opacity: .5, borderLeft: '8px solid transparent' }}
                >
                    <img src='/secondary/menu/task.png' alt='' style={{ height: '36px', objectFit: 'contain' }} />
                    <div className='font-[700] flex-1 text-center' style={{ color: ['results'].includes(location.pathname.split('/')[2]) ? "#43528A" : '#34778C' }}>學習記錄</div>
                </div>
                <div onClick={handleRoute('achievement')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[16px] p-[16px] gap-[8px] pr-[24px]'
                    style={['achievement'].includes(location.pathname.split('/')[2]) ? { opacity: 1, background: 'linear-gradient(to right, #10AEC450, #FFFFFF)', borderLeft: '8px solid #10AEC4' } : { opacity: .5, borderLeft: '8px solid transparent' }}
                >
                    <img src='/secondary/menu/teach.png' alt='' style={{ height: '36px', objectFit: 'contain' }} />
                    <div className='font-[700] flex-1 text-center' style={{ color: ['achievement'].includes(location.pathname.split('/')[2]) ? "#43528A" : '#34778C' }}>我的成就</div>
                </div>
                <div onClick={handleRoute('user')} className='cursor-pointer flex flex-row items-center bg-[#FFFFFF] rounded-[16px] p-[16px] gap-[8px] pr-[24px]'
                    style={['user'].includes(location.pathname.split('/')[2]) ? { opacity: 1, background: 'linear-gradient(to right, #10AEC450, #FFFFFF)', borderLeft: '8px solid #10AEC4' } : { opacity: .5, borderLeft: '8px solid transparent' }}
                >
                    <img src='/secondary/menu/info.png' alt='' style={{ height: '36px', objectFit: 'contain' }} />
                    <div className='font-[700] flex-1 text-center' style={{ color: ['user'].includes(location.pathname.split('/')[2]) ? "#43528A" : '#34778C' }}>個人資料</div>
                </div>
            </div>

            <div onClick={handleLogout} className='w-full cursor-pointer flex flex-row justify-center items-center bg-[#FFFFFF] rounded-[16px] p-[16px] gap-[20px] mt-[16px]'>
                <img src='/secondary/menu/logout.png' alt='' style={{ height: '36px', objectFit: 'contain' }} />
                <div className='font-[700] text-center' style={{ color: 'black' }}>登出</div>
            </div>
        </div>
    )
}
export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)